const queryString = params =>
  Object.entries(params)
    .filter(([, v]) => v != null && String(v).trim() !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&');

export const PUBLIC_DATA_STATIC_MAP_URL_KEY = 'seaticsStaticMapUrl';

const seaticsMapViaProxyEnabled = () =>
  String(process.env.REACT_APP_SEATICS_MAP_VIA_PROXY || 'true').toLowerCase() !== 'false';

const resolveMapsBaseUrl = raw => {
  const base = String(raw || 'https://sandbox.tn-apis.com/maps/v3').replace(/\/$/, '');
  return /\/maps\/v3$/i.test(base) ? base : `${base}/maps/v3`;
};

/** Same-origin or direct TN MapAndLayout script URL for `<link rel="preload" as="script">`. */
export const seaticsMapBootstrapUrl = publicData => {
  const eventId = publicData?.ticketNetworkEventId;
  if (!eventId) return null;
  if (seaticsMapViaProxyEnabled()) {
    const params = {
      eventId,
      eventName: publicData?.eventName || '',
      venue: publicData?.venue || '',
    };
    return `/api/tn-seatics/map-and-layout?${queryString(params)}`;
  }
  const websiteConfigId = process.env.REACT_APP_SEATICS_WEBSITE_CONFIG_ID;
  const consumerKey = process.env.REACT_APP_SEATICS_CONSUMER_KEY;
  if (!websiteConfigId || !consumerKey) return null;
  const base = resolveMapsBaseUrl(process.env.REACT_APP_SEATICS_MAPS_BASE_URL);
  const params = {
    eventId,
    websiteConfigId,
    consumerKey,
    eventName: publicData?.eventName || '',
    venue: publicData?.venue || '',
  };
  return `${base}/MapAndLayout?${queryString(params)}`;
};

export const seaticsStaticMapUrlFromListing = listing => {
  const url = listing?.attributes?.publicData?.[PUBLIC_DATA_STATIC_MAP_URL_KEY];
  return typeof url === 'string' && url.trim() ? url.trim() : null;
};

export const isTnEventListingPublicData = publicData => {
  const pd = publicData || {};
  return (
    pd.ticketNetworkEventListing === true ||
    pd.ticketNetworkListingMode === 'event' ||
    !!pd.ticketNetworkEventId
  );
};
